import {
    Stack, Container,
    Box,
} from '@mui/material'
import { useEffect, useState, useContext } from 'react'
import { ProfileContext } from '../../contexts/ProfileContext';
import * as api from '../../api/Manual'
import {
    ModalError,
    BackDropLoading,
    CardMenu
} from '../../ui-component';
export const Manual = () => {
    const [listMenu, setListMenu] = useState([])
    const [profile, setProfile] = useState(null)
    const [houseInfo, setHouseInfo] = useState(null)
    const [modalError, setModalError] = useState({ errorResponse: null, open: false });
    const [loading, setLoading] = useState(false)
    const context = useContext(ProfileContext)

    useEffect(() => {
        if (profile !== null) {
            const loadMenuList = async () => {
                setLoading(true)
                let res = await api.getManualList({
                    "line_id": profile?.line_id,
                    "product_type": houseInfo?.product_type,
                    "project_id": houseInfo?.project_id,
                })
                if (res?.status === 200) {
                    setListMenu(res.data?.data.post)
                    setLoading(false)
                    return
                }
                setLoading(false)
                setModalError({ errorResponse: res, open: true })
                return
            }
            loadMenuList()
        }
    }, [profile, houseInfo]);

    useEffect(() => {
        if (context.state?.profile !== null) {
            setProfile(context.state?.profile?.customer[0])
        }

        if (context?.state.houseInfo) {
            setHouseInfo(context?.state?.houseInfo)
        }
    }, [context])
    return (
        <>
            <Box sx={{ height: "calc(100vh - 60px)" }}>

                <Container sx={{ minHeight: "100%", paddingTop: 2, paddingBottom: 5 }} >
                    <Stack mt={1} spacing={2}>
                        {
                            listMenu?.map(element =>
                                <CardMenu iconImg={"pdfIcon"} key={element.id} text={element[`title_${profile?.language}`]}
                                    navigate={"detail"} state={{ title: element[`title_${profile?.language}`], id: element.id }} />
                            )
                        }
                    </Stack>
                </Container>
            </Box >
            <ModalError
                onClose={() => setModalError({ errorResponse: null, open: false })}
                open={modalError.open}
                error={modalError.errorResponse}
            />
            <BackDropLoading
                loading={loading}
            />

        </>
    )

}